export default __webpack_public_path__ + "static/media/ic-add.31c10c72.svg";